import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../services/auth-service.service';
import { LocalServiceService } from '../../../services/local-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chatmemory',
  templateUrl: './chat-memory.component.html',
  styleUrls: ['./chat-memory.component.scss'],
})
export class ChatMemoryComponent implements OnInit {
  isLoading: boolean = false;
  instructions: any = [];

  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private local: LocalServiceService,
  ) {}

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.isLoading = true;
    this.auth.chatGetInstruction({}).subscribe(
      (response: any) => {
        this.isLoading = false;
        console.log(response.body);
        this.instructions = response.body;
      },
      () => {
        this.isLoading = false;
        this.toastr.error('Failed to fetch Instructions');
      },
    );
  }

  handleDelete(index: any) {
    // return alert(index)
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});

        this.auth
          .chatDeleteInstruction({ instrnum: index.toString() })
          .subscribe(
            () => {
              Swal.close();
              this.initData();
              this.toastr.success('Successfully deleted Instructions');
            },
            () => {
              Swal.close();
              this.isLoading = false;
              this.toastr.error('Failed to fetch Instructions');
            },
          );
      }
    });
  }
}
